import React from "react";
import logo from "./Images/EssemieBlack.svg";

const LogoBlack = () => {
  return (
    <div className="xs:translate-x-[30px] max-xs:translate-x-[20px]">
      <img src={logo} className="lg:h-[40px] md:h-[32px] h-[28px]" alt="logo" />
    </div>
  );
};

export default LogoBlack;
